module.exports = __webpack_public_path__ + "static/media/boatramp_marker_light_blue.9e4783f5.svg";